<template>
  <div id="system-publish-database">
    <div class="ipub-filter-div">
      <div class="ipub-filter-div-content">
        <ipub-row :gutter="[12,16]">
          <ipub-col :span="12">
            <site-search-group v-model.trim="params.name"
                               placeholder="Search by announcement name"
                               @search="getList()"
                               @clear="handleClear" />
          </ipub-col>
        </ipub-row>
        <template v-if="showHandleDate">
          <ipub-row :gutter="[12,16]">
            <ipub-col :span="6"
                      class="flex"
                      style="align-items:center">
              <span class="line-h-40 nowrap fw-bd">Publish Date</span>
              <ipub-date-range-picker class="mar-l-12"
                                      style="width:calc(100% - 100px)"
                                      :placeholder="['From','To']"
                                      @change="publishedDateChange"
                                      v-model="publishedDate" />
            </ipub-col>
          </ipub-row>
        </template>
      </div>
      <a class="ipub-filter-div-button"
         @click="()=>{showHandleDate = !showHandleDate}">
        Advanced
        <ipub-icon :class="['mar-l-10 rotate',showHandleDate?'rotate-180':'']"
                   type="iconArrow" />
      </a>
    </div>
    <div class="relative ipub-p1 mar-b-30">
      <div class="ipub-tab-list">
        <a @click="changeStatus('')"
           :class="['ipub-tab-list--tab',params.released===''?'active':'']">All Status</a>
        <a @click="changeStatus(true)"
           :class="['ipub-tab-list--tab',params.released===true?'active':'']">Published</a>
        <a @click="changeStatus(false)"
           :class="['ipub-tab-list--tab',params.released===false?'active':'']">Draft</a>
      </div>
      <div class="right-option">
        <ipub-button v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.ANNOUNCEMENT.ADD')"
                     type="primary"
                     @click="add">
          Add New Announcement
        </ipub-button>
      </div>
    </div>

    <div class="page-content">
      <ipub-table :columns="columns"
                  :pagination="false"
                  draggable
                  @order="onOrderChanage"
                  @drag="setSort"
                  :dataSource="dataSource">
        <template v-slot:time="{record}">
          {{ (record.updateTime||record.createTime)?$moment(record.updateTime||record.createTime).format('HH : mm DD / MM / YYYY'): '- -' }}
        </template>
        <template v-slot:status="{text}">
          <ipub-label size="small"
                      type="success"
                      style="width:80px"
                      cover
                      v-if="text">Published</ipub-label>
          <ipub-label size="small"
                      type="danger"
                      style="width:80px"
                      cover
                      v-else>Draft</ipub-label>
        </template>
        <template v-slot:actions="{ record }">
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.ANNOUNCEMENT.EDIT')"
                        class="border-right">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEdit"
                       @click="edit(record)" />
          </ipub-tooltip>
          <template v-if="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.ANNOUNCEMENT.PUBLISH')">
            <ipub-tooltip v-if="record.released"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('WEBSITE.JOURNAL_WEBSITE.ANNOUNCEMENT.DELETE')">
            <div slot="title">Delete</div>
            <ipub-icon type="iconDelete"
                       @click="del(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <Add ref="database-add"
         :inputData="inputData"
         :isVisable="isVisable"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
